/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface ApplicationResponsiblePersonResponse
 */
export interface ApplicationResponsiblePersonResponse {
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponsiblePersonResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof ApplicationResponsiblePersonResponse
     */
    userType?: UserType;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponsiblePersonResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponsiblePersonResponse
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationResponsiblePersonResponse
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponsiblePersonResponse
     */
    isApplicationAdministrator?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponsiblePersonResponse
     */
    canManageAccessRequestsForApplication?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationResponsiblePersonResponse
     */
    canAppointExternalApproversForApplication?: boolean;
}



/**
 * Check if a given object implements the ApplicationResponsiblePersonResponse interface.
 */
export function instanceOfApplicationResponsiblePersonResponse(value: object): value is ApplicationResponsiblePersonResponse {
    return true;
}

export function ApplicationResponsiblePersonResponseFromJSON(json: any): ApplicationResponsiblePersonResponse {
    return ApplicationResponsiblePersonResponseFromJSONTyped(json, false);
}

export function ApplicationResponsiblePersonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationResponsiblePersonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'firstName': json['firstName'] === undefined ? undefined : json['firstName'] === null ? null : json['firstName'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'isApplicationAdministrator': json['isApplicationAdministrator'] == null ? undefined : json['isApplicationAdministrator'],
        'canManageAccessRequestsForApplication': json['canManageAccessRequestsForApplication'] == null ? undefined : json['canManageAccessRequestsForApplication'],
        'canAppointExternalApproversForApplication': json['canAppointExternalApproversForApplication'] == null ? undefined : json['canAppointExternalApproversForApplication'],
    };
}

export function ApplicationResponsiblePersonResponseToJSON(json: any): ApplicationResponsiblePersonResponse {
    return ApplicationResponsiblePersonResponseToJSONTyped(json, false);
}

export function ApplicationResponsiblePersonResponseToJSONTyped(value?: ApplicationResponsiblePersonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userType': UserTypeToJSON(value['userType']),
        'firstName': value['firstName'],
        'surname': value['surname'],
        'name': value['name'],
        'isApplicationAdministrator': value['isApplicationAdministrator'],
        'canManageAccessRequestsForApplication': value['canManageAccessRequestsForApplication'],
        'canAppointExternalApproversForApplication': value['canAppointExternalApproversForApplication'],
    };
}

